import { createIcon } from '../../createIcon';
import { withIcon } from '../../withIcon';
import { RefreshSvg } from './Refresh';

export const RefreshIcon = createIcon('refresh', RefreshSvg);
/**
 * @deprecated используйте RefreshIcon
 */
export const withRefreshIcon = withIcon('refresh', RefreshSvg);
